/**
 * Geometry for the M1 panel fabric, transcribed from the design export.
 *
 * The fabric is painted as two background layers on the panel surface:
 * a repeating dot tile above a single panel-sized gradient. The tile
 * keeps a fixed pixel pitch so the dots stay the same size no matter
 * how tall or wide the drawer gets, while the gradient stretches to
 * fill it.
 *
 * Lives in a dedicated constants file (per `.cursor/rules/react/react.mdc`
 * "Component Constants": component files should never export constants).
 */

/** Horizontal dot pitch (px). */
export const FABRIC_DOT_TILE_WIDTH_PX = 17.4796;

/** Vertical dot pitch (px). */
export const FABRIC_DOT_TILE_HEIGHT_PX = 16.5749;

/** Horizontal radius (px) of a single dot. */
export const FABRIC_DOT_RADIUS_X_PX = 0.9711;

/** Vertical radius (px) of a single dot. */
export const FABRIC_DOT_RADIUS_Y_PX = 0.9208;

/** Phase offset of the repeating dot tile against the panel edges. */
export const FABRIC_DOT_POSITION = '0.824px 0.52px';

/** Alpha the gradient carries where the dots expose it. */
export const FABRIC_GRADIENT_ALPHA = 0.4;

/**
 * Gradient direction: up and slightly left, so the ramp starts in the
 * bottom-right corner the way the export does.
 */
export const FABRIC_GRADIENT_ANGLE = '336deg';
